import { useLottie } from 'lottie-react';
import wandLoaderData from './json/wand_loader.json';
import notificationData from './json/notification.json';

const LottieAnimation = ({ animationData, size }: { animationData: any; size: number }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };
  const style = {
    height: size,
    width: size,
    display: 'flex',
  };

  const { View } = useLottie(defaultOptions, style);
  return View;
};

const WandLoader = ({ size }: { size: number }) => (
  <LottieAnimation animationData={wandLoaderData} size={size} />
);

const NotificationAnimation = ({ size }: { size: number }) => (
  <LottieAnimation animationData={notificationData} size={size} />
);

export { WandLoader, NotificationAnimation };
